/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'


//import firebase from 'firebase/app'
//import 'firebase/auth'
import router from '@/router'

export default {
  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password,payload.userDetails.recaptcha)
        .then(response => {
          
          // If there's user data in response
          if (response.data.userData) {

            // Set accessToken
            localStorage.setItem('accessToken', response.data.access_token)
            localStorage.setItem('tokenExpiry', response.data.userData.expire_at)
            localStorage.setItem('loggedIn', true)
            localStorage.setItem('permissions', JSON.stringify(response.data.permissions))      
            localStorage.setItem('roles', JSON.stringify(response.data.roles)) 
            localStorage.setItem('pua', JSON.stringify(response.data.password_updated_at))   
            localStorage.setItem('cell',response.data.cell)   
            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.data.access_token)
            // Navigate User to homepage
            //router.push(router.currentRoute.query.to || '/')
            resolve(response)
          } else {
            reject({message: response.data})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem('accessToken', response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
